<div
    class="tw-relative tw-max-w-full tw-h-[320px] tw-max-h-[320px] lg:tw-h-[510px] lg:tw-max-h-[510px] tw-bg-[url('assets/images/Jc3/tablet-banner.png')] xl:tw-bg-[url('assets/images/Jc3/hero-banner.png')] tw-overflow-hidden tw-bg-cover tw-bg-center"
>
    <img
        *ngIf="desktopBanner"
        class="tw-absolute lg:tw-block tw-hidden tw-top-0 tw-left-0 tw-w-full tw-h-full tw-object-cover"
        [src]="desktopBanner"
    />
    <img
        *ngIf="tabletBanner"
        class="tw-absolute lg:tw-hidden tw-block tw-top-0 tw-left-0 tw-w-full tw-h-full"
        [src]="tabletBanner"
    />
</div>
